module.exports = __webpack_public_path__ + "img/czleader6.c38fb5cb.png";